window.initSwiper = function (sectionId, productId) {
  var swiper5 = new Swiper(".slider-card-" + sectionId + "-" + productId, {
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
    grid: {
      rows: 1,
      fill: 'row',
    },
    navigation: {
      nextEl: '.swiper-next-' + sectionId + "-" + productId,
      prevEl: '.swiper-prev-' + sectionId + "-" + productId,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.swiper-wrapper');

  sliders.forEach(function (slider) {
    const sectionId = slider.getAttribute('data-section-id');
    const productId = slider.getAttribute('data-product-id');

    if (sectionId && productId) {
      window.initSwiper(sectionId, productId);
    }
  });
});

// menu toggler js
document.querySelector("button.navbar-toggle")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer").classList.add("active");
  document.querySelector(".mm-fullscreen-bg").classList.add("active");
  document.body.classList.add("ov-hidden");
  const drawer = document.querySelector('.menu-drawer');
  trapFocus(drawer);
  const escHandler = (evt) => {
    if (evt.code === 'Escape') {
      document.querySelector(".menu-drawer")?.classList.remove("active");
      document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
      document.body.classList.remove("ov-hidden");
      const drawerbtn = document.querySelector('button.navbar-toggle');
      removeTrapFocus(drawerbtn);
      document.removeEventListener('keyup', escHandler); // Cleanup listener
    }
  };
  document.addEventListener('keyup', escHandler);
});

// Menu drawer close
document.querySelector(".menu-drawer-close")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
  const drawerbtn = document.querySelector('button.navbar-toggle');
  removeTrapFocus(drawerbtn);
});

// Filter button
document.querySelector("button.filter-button")?.addEventListener("click", function() {
  document.querySelector(".filter-sidebar")?.classList.add("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.add("active");
  document.body.classList.add("ov-hidden");
  const drawer = document.querySelector('.filter-sidebar');
  trapFocus(drawer);
  const escHandler = (evt) => {
    if (evt.code === 'Escape') {
      document.querySelector(".filter-sidebar")?.classList.remove("active");
      document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
      document.body.classList.remove("ov-hidden");
      const drawerbtn = document.querySelector('button.filter-button');
      removeTrapFocus(drawerbtn);
      document.removeEventListener('keyup', escHandler); // Cleanup listener
    }
  };
  document.addEventListener('keyup', escHandler);
});

document.querySelector("button.close-filter-sidebar")?.addEventListener("click", function() {
  document.querySelector(".filter-sidebar")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
  const drawerbtn = document.querySelector('button.filter-button');
  removeTrapFocus(drawerbtn);
});

// Body background click
document.querySelector(".mm-fullscreen-bg")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer")?.classList.remove("active");
  document.querySelector(".filter-sidebar")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
});

// Enable/disable button based on checkbox
document.querySelector(".read-agree")?.addEventListener("click", function() {
  const checkbox = document.querySelector(".create-checkbox");
  const button = document.querySelector(".create");
  if (checkbox?.checked) {
    button?.removeAttribute("disabled");
  } else {
    button?.setAttribute("disabled", "disabled");
  }
});

// Function to change the product image based on the selected color
function changeProductImage(event) {
  // Get the selected radio button
  const selectedColor = event.target;

  // Find the closest product item container
  const productItem = selectedColor.closest('.single-product-wrap');

  // Get the main product image within the product item
  const productImage = productItem.querySelector('img');

  // Get the new image URL from the data-image attribute
  const newImageUrl = selectedColor.getAttribute('data-image');

  // Update the main product image src
  productImage.srcset = newImageUrl;
}

// Add event listeners to all color options
document.querySelectorAll('.pr-gr-option input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', changeProductImage);
});

// Level 1 menu arrow click
document.addEventListener("click", function(e) {
  if (e.target.closest(".menu-arrow")) {
    const arrow = e.target.closest(".menu-arrow");
    const menuLink = arrow.closest("li");
    const mainMenu = menuLink.querySelector(".menu-dropdown");

    if (menuLink.classList.contains("open")) {
      menuLink.classList.remove("open");
      document.querySelector(".menu-content")?.classList.remove("open-level-1");
    } else {
      mainMenu?.classList.add("open");
      menuLink.classList.add("open");
      document.querySelector(".menu-content")?.classList.add("open-level-1");
    }

    e.stopPropagation();
    // Prevent default only if not inside <summary>
    if (!arrow.closest("summary")) {
      e.preventDefault();
    }
  }
});

// Level 2 submenu arrow click
document.addEventListener("click", function(e) {
  if (e.target.closest(".menu-arrow-sub")) {
    const arrow = e.target.closest(".menu-arrow-sub");
    const menuLink = arrow.closest("li");
    const mainMenu = menuLink.querySelector(".supmenu-dropdown");

    if (menuLink.classList.contains("open")) {
      menuLink.classList.remove("open");
      document.querySelector(".menu-content")?.classList.remove("open-level-2");
    } else {
      mainMenu?.classList.add("open");
      menuLink.classList.add("open");
      document.querySelector(".menu-content")?.classList.add("open-level-2");
    }

    e.stopPropagation();
    // Prevent default only if not inside <summary>
    if (!arrow.closest("summary")) {
      e.preventDefault();
    }
  }
});

// Back button in level 1 menu
document.addEventListener("click", function(e) {
  if (e.target.closest(".back-menu")) {
    const backMenu = e.target.closest(".menu-dropdown");
    setTimeout(() => {
      backMenu?.classList.remove("open");
    }, 500);
    document.querySelectorAll(".menu-link").forEach(el => el.classList.remove("open"));
    document.querySelector(".menu-content")?.classList.remove("open-level-1");

    e.stopPropagation();
    e.preventDefault();
  }
});

// Back button in level 2 submenu
document.addEventListener("click", function(e) {
  if (e.target.closest(".back-menu-sub")) {
    const backMenu = e.target.closest(".supmenu-dropdown");
    setTimeout(() => {
      backMenu?.classList.remove("open");
    }, 500);
    document.querySelectorAll(".singlemenu-li").forEach(el => el.classList.remove("open"));
    document.querySelector(".menu-content")?.classList.remove("open-level-2");

    e.stopPropagation();
    e.preventDefault();
  }
});

// Function to open modal
function openModal(modalId, focusElement) {
  this.focusElement = focusElement;
  const modal = document.getElementById(modalId);                                                         
  console.log(modal);
  modal.classList.add('show');
  document.body.classList.add('ov-hidden');
  const modals = document.querySelector('.modal.show');
  trapFocus(modals);
}  

// Function to close modal
function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  modal.classList.remove('show');
  document.body.classList.remove('ov-hidden');
  removeTrapFocus(this.focusElement);
}
// Add event listeners to buttons to open modals
document.querySelectorAll('.modal-button').forEach(function (button) {
  button.addEventListener('click', function () {
    const modalId = button.getAttribute('data-modal');
    openModal(modalId, button);
    const escHandler = (evt) => {
      if (evt.code === 'Escape') {
        closeModal(modalId);
        document.removeEventListener('keyup', escHandler); // Cleanup listener
      }
    };
    document.addEventListener('keyup', escHandler);
  });
});
// Add event listeners to close buttons within modals
document.querySelectorAll('.close').forEach(function (btn) {
  btn.addEventListener('click', function () {
      const modalId = btn.getAttribute('data-modal');
      closeModal(modalId);
  });
});

// Add event listener to window to close modals when clicking outside
window.addEventListener('click', function (event) {
  const modals = document.querySelectorAll('.modal');
  modals.forEach(function (modal) {
    if (event.target == modal) {
      modal.classList.remove('show');
      document.body.classList.remove('ov-hidden');
      removeTrapFocus(this.focusElement);
    }
  });
});


// Tab
const tabContainers = document.querySelectorAll('.tab-container');

function activateTab(container, tabId) {
  const tabs = container.querySelectorAll('.tab-button');
  const contents = container.querySelectorAll('.tab-pane');

  tabs.forEach(tab => tab.classList.remove('active'));
  contents.forEach(content => {
    content.classList.remove('active');
    content.style.display = 'none';
  });

  const activeTab = container.querySelector(
    `.tab-button[tab-id="${tabId}"]`
  );
  const activeContent = container.querySelector('#' + tabId);

  if (activeTab && activeContent) {
    activeTab.classList.add('active');
    activeContent.style.display = 'block';

    // small delay for fade animation
    requestAnimationFrame(() => {
      activeContent.classList.add('active');
    });
  }
}

tabContainers.forEach(container => {
  const tabs = container.querySelectorAll('.tab-button');
  const nav = container.querySelector('.nav-tabs');

  /* ---------- DEFAULT ACTIVE (ALWAYS) ---------- */
  if (tabs.length) {
    activateTab(container, tabs[0].getAttribute('tab-id'));
  }

  /* ---------- TAB CLICK ---------- */
  nav.addEventListener('click', function (event) {
    const tabButton = event.target.closest('.tab-button');
    if (!tabButton) return;

    const tabId = tabButton.getAttribute('tab-id');
    activateTab(container, tabId);
  });
});

/* ---------- DESIGN MODE: BLOCK CLICK ---------- */
if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', function (event) {
    const { blockId, sectionId } = event.detail;

    const section = document.querySelector(
      `#shopify-section-${sectionId}`
    );
    if (!section) return;

    const container = section.querySelector('.tab-container');
    if (!container) return;

    const tabButton = container.querySelector(
      `.tab-button[data-block-id="${blockId}"]`
    );
    if (!tabButton) return;

    const tabId = tabButton.getAttribute('tab-id');
    activateTab(container, tabId);
  });
}


// collapse

// collapse — delegated so it also works inside quick view / dynamically injected content
document.addEventListener('click', function (e) {
  const button = e.target.closest('.dropdown-btn');
  if (!button) return;

  const targetClass = button.getAttribute('data-target');
  const dropdownContents = document.querySelectorAll(targetClass);

  dropdownContents.forEach(dropdownContent => {
    if (dropdownContent.classList.contains('show')) {
      // Close
      dropdownContent.style.height = dropdownContent.scrollHeight + 'px';
      dropdownContent.offsetHeight; // force repaint
      dropdownContent.style.height = '0px';

      dropdownContent.addEventListener('transitionend', function () {
        if (!dropdownContent.classList.contains('show')) {
          dropdownContent.style.removeProperty('height');
        }
      }, { once: true });

      dropdownContent.classList.remove('show');
      button.classList.remove('show');
    } else {
      // Open
      dropdownContent.style.height = dropdownContent.scrollHeight + 'px';

      dropdownContent.addEventListener('transitionend', function () {
        if (dropdownContent.classList.contains('show')) {
          dropdownContent.style.height = 'auto';
        }
      }, { once: true });

      dropdownContent.classList.add('show');
      button.classList.add('show');
    }
  });
});


// accordion

// accordion — delegated
document.addEventListener('click', function (e) {
  const button = e.target.closest('.accordian-btn');
  if (!button) return;

  const targetId = button.getAttribute('data-target');
  const targetContent = document.querySelector(targetId);

  document.querySelectorAll('.accordian-content').forEach(content => {
    if (content !== targetContent) {
      content.style.height = '0px';
      content.classList.remove('show');
    }
  });

  document.querySelectorAll('.accordian-btn').forEach(btn => {
    if (btn !== button) btn.classList.remove('show');
  });

  if (targetContent) {
    if (targetContent.classList.contains('show')) {
      targetContent.style.height = '0px';
      targetContent.classList.remove('show');
      button.classList.remove('show');
    } else {
      targetContent.style.height = targetContent.scrollHeight + 'px';
      targetContent.classList.add('show');
      button.classList.add('show');
    }
  }
});


const getScrollTop = (element) => {
  let offsetTop = 0
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop
    }
  } while ((element = element.offsetParent))
  return offsetTop
}
const portView = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;
  return windowBottom >= getScrollTop(element);
}


if ('.week-countdown') {
  document.querySelectorAll('.week-countdown').forEach(function (el) {
  var endDate = el.getAttribute('data-id');
  var endDate = el.getAttribute('data-enddate');
  var parsedDate = new Date(endDate);

  if (!isNaN(parsedDate)) {
  function updateCountdown() {
    var now = new Date().getTime();
    var distance = parsedDate - now;

    if (distance <= 0) {
      el.style.display = 'none';
      clearInterval(interval);
      return;
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    el.querySelector('ul').innerHTML = `
      <li><div class="timer-block"><div class="timer-info"><p class='m-0'>${days}</p> <span>${el.dataset.dayTitle || 'D'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><p class='m-0'>${hours}</p> <span>${el.dataset.hourTitle || 'H'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><p class='m-0'>${minutes}</p> <span>${el.dataset.minuteTitle || 'M'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><p class='m-0'>${seconds}</p> <span>${el.dataset.secondTitle || 'S'}</span></div></div></li>
  `;
  }
  updateCountdown(); // Initial call
  var interval = setInterval(updateCountdown, 1000);
  }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const videoBackgrounds = document.querySelectorAll('video-background-component');

  videoBackgrounds.forEach(videoBackground => {
    const videoSources = videoBackground.querySelectorAll('[data-video-source]');
    const videoElement = videoBackground.querySelector('video');

    if (!videoSources.length || !videoElement) return;

    videoSources.forEach(source => {
      const videoSource = source.dataset.videoSource;
      if (videoSource) {
        source.setAttribute('src', videoSource);
      }
    });

    videoElement.load();
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const signupBlocks = document.querySelectorAll('.email-signup-block');

  signupBlocks.forEach(block => {
    const form = block.querySelector('form');
    const emailInput = block.querySelector('#E-mail');
    const newsContent = block.querySelector('.news-content');

    if (!form || !emailInput || !newsContent) return;

    form.addEventListener(
      'submit',
      function (e) {
        const email = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!emailRegex.test(email)) {
          e.preventDefault();
          e.stopImmediatePropagation(); // 🚫 Shopify submit block

          emailInput.classList.add('error');
          emailInput.focus();
          showEmailError(block, newsContent, 'Please enter a valid email address');
          return false;
        }

        hideEmailError(block);
        emailInput.classList.remove('error');
      },
      true // ⚠️ capture phase (very important)
    );
  });

  function showEmailError(block, newsContent, message) {
    let error = block.querySelector('.email-error-custom');

    if (!error) {
      error = document.createElement('div');
      error.className = 'email-error-custom';
      error.setAttribute('role', 'alert');

      // 👇 error always under that form's .news-content
      newsContent.after(error);
    }

    error.textContent = message;
  }

  function hideEmailError(block) {
    const error = block.querySelector('.email-error-custom');
    if (error) error.remove();
  }
});

document.querySelectorAll('a[href]').forEach(link => {
  link.setAttribute('tabindex', '0');
});

document.querySelectorAll('.details').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (details.open) {
      const content = details.querySelector('.details-content');

      trapFocus(
        details,          // container → WHOLE details
        content.querySelector('input, button, a') // first focus
      );
    } else {
      removeTrapFocus();
    }
  });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.pop-close');
  if (!btn) return;

  const details = btn.closest('details');
  if (details) {
    details.removeAttribute('open'); // close details
  }
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;

  const openDetails = document.querySelector('details[open]');
  if (openDetails) {
    openDetails.removeAttribute('open');

    // optional: focus back to summary for accessibility
    const summary = openDetails.querySelector('summary');
    if (summary) summary.focus();
  }
});

const details = document.querySelector('.search-details');
const bg = document.querySelector('.mm-fullscreen-bg');

if (details && bg) {
  details.addEventListener('toggle', () => {
    bg.classList.toggle('active', details.open);
  });
}
document.addEventListener('click', function(e) {
  const btn = e.target.closest('#mobile-search-trigger');

  if (!btn) return;

  e.preventDefault();

  const summary = document.querySelector('.search-details .search-popup');

  if (summary) {
    summary.click();
  }
});